<template>
    <div class="card col-12 mx-auto">
        <div class="card-header bg-primary text-white">
            <div class="card-title h5 m-0">
                <page-title :title="$t('sideMenu.participants')" :showTitle="true"></page-title>
            </div>
        </div>

        <div class="card-body">
            <div class="alert alert-light m-2 p-2" role="alert">
                <p><i class="fas fa-info-circle ml-2 mr-1"></i>{{ $t('registers.participants.help.participantsGridInfo')}}</p>
            </div>

            <all-appearances-grid ref="allAppearancesGrid"
                                  :showHideButton="false"
                                  :showPinButton="false"
                                  :showNewButton="false"
                                  :showResizeIcon="false"
                                  :showSettingsBtn="true"
                                  :showBtns="true"
                                  :expandFirstMasterDetails="false"
                                  :onlyParticipants="true"
                                  :componentName="'ParticipantRegisterListGrid'">
            </all-appearances-grid>
        </div>
    </div>
   
</template>

<script>
    import AllAppearancesGrid from "../../../components/participants/AllAppearancesGrid";
    import PageTitle from '../../../components/common/PageTitle';
  

    export default {
        components: {
            AllAppearancesGrid,
            PageTitle
        },
        data () {
            return {
               
            }
        },
        methods: {
            
        }
    }
</script>

<style scoped>

</style>
